import { render } from "./SysTitleCard.vue?vue&type=template&id=7fae0f68&scoped=true&ts=true"
import script from "./sysTitleCardHelper.ts?vue&type=script&lang=ts"
export * from "./sysTitleCardHelper.ts?vue&type=script&lang=ts"

import "./SysTitleCard.vue?vue&type=style&index=0&id=7fae0f68&scoped=true&lang=css"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fae0f68"]])

export default __exports__